import { Box, IconButton, List, ListItem, ListItemText, SxProps, Theme, Typography } from '@mui/material';
import React, { FC, memo, useCallback, useMemo } from 'react';
import { useEditContext, useEquipmentsContext } from './create-site-context-provider';
import { localized } from 'shared/state/i18n/i18n';

interface Props {
	openEquipmentForm: () => void;
}

export const EquipmentList: FC<Props> = memo(({ openEquipmentForm }) => {
	const { equipments, removeEquipment } = useEquipmentsContext();
	const { startEditingProcessEquipment, editingSiteId } = useEditContext();

	const viewEquipment = useCallback(
		(code: string) => {
			startEditingProcessEquipment(code);
			openEquipmentForm();
		},
		[openEquipmentForm, startEditingProcessEquipment],
	);

	const buttonStyle: SxProps<Theme> = useMemo(() => {
		return {
			borderRadius: '50',
			height: '25px',
			width: '25px',
		};
	}, []);

	const viewButton = useCallback(
		(code: string) => {
			return (
				<IconButton onClick={() => viewEquipment(code)} sx={buttonStyle}>
					<Typography>{localized('Edit')}</Typography>
				</IconButton>
			);
		},
		[buttonStyle, viewEquipment],
	);

	return (
		<Box sx={{ flex: 1, overflow: 'auto' }}>
			<List>
				{equipments.map((equipment, index) => (
					<ListItem
						key={index}
						sx={{ backgroundColor: index % 2 === 0 ? '#ffffff' : '#f5f5f5' }}
						secondaryAction={
							editingSiteId ? (
								viewButton(equipment.code!)
							) : (
								<IconButton onClick={() => removeEquipment(equipment)} sx={buttonStyle}>
									✕
								</IconButton>
							)
						}
					>
						<ListItemText
							primary={equipment.equipment}
							secondary={[equipment.ipAddress, equipment.code].filter(Boolean).join(' - ')}
						/>
					</ListItem>
				))}
			</List>
		</Box>
	);
});
